const visibleColumns = [
  // {
  //   title: "ID",
  //   field: "id",
  //   locked: false,
  //   filter: "numeric",
  //   width: 120,
  //   show: true,
  //   className: "text-end",
  //   headerClassName: "number-align",
  // },
  // {
  //   title: "Employee ID",
  //   field: "employeeid",
  //   locked: false,
  //   filter: "numeric",
  //   customFilterType: "CustomNumericText",
  //   width: 180,
  //   show: true,
  //   className: "text-end",
  //   headerClassName: "number-align",
  // },
  // {
  //   title: "Employee Name",
  //   field: "employee_name",
  //   locked: true,
  //   filter: "text",
  //   width: 400,
  //   show: true,
  // },
  // {
  //   title: "Department",
  //   field: "DepartmentName",
  //   locked: false,
  //   filter: "text",
  //   width: 400,
  //   show: true,
  // },
  {
    title: "Leave Type",
    field: "paycode_name",
    locked: false,
    filter: "text",
    width: 350,
    show: true,
  },
  // {
  //   title: "Leave Date",
  //   field: "leavedate",
  //   locked: false,
  //   filter: "date",
  //   format: "MM/DD/YYYY",
  //   editor: "date",
  //   width: 190,
  //   show: true,
  // },
  {
    title: "Total Hours",
    field: "TotalLeaveHours",
    locked: false,
    filter: "numeric",
    width: 160,
    show: true,
    className: "text-end",
    headerClassName: "number-align",
  },
  // {
  //   title: "Pay Code",
  //   field: "paycode",
  //   locked: false,
  //   filter: "text",
  //   width: 150,
  //   show: true,
  // },
  // {
  //   title: "Division Name",
  //   field: "DivisionName",
  //   locked: false,
  //   filter: "text",
  //   width: 150,
  //   show: true,
  // },
  // {
  //   title: "Dept Code",
  //   field: "deptcode",
  //   locked: false,
  //   filter: "text",
  //   width: 150,
  //   show: true,
  // },
];

export default visibleColumns;
